import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Create a notification in Firestore
 * @param {string} type - "new_member" | "attendance" | "poster" | "profile" | "general"
 * @param {string} title - Short title
 * @param {string} message - Longer description
 * @param {string[]} recipients - Array of UIDs or ["all"] for everyone
 */
export async function createNotification({ type, title, message, recipients = ["all"] }) {
  try {
    await addDoc(collection(db, "notifications"), {
      type,
      title,
      message,
      recipients,
      readBy: [],
      createdAt: serverTimestamp(),
    });
  } catch(e) {
    console.error("Failed to create notification:", e);
  }
}

// ── Preset helpers ──

export function notifyNewMember(name, role) {
  return createNotification({
    type: "new_member",
    title: `New ${role} joined!`,
    message: `${name} has been added to Help Them Shine Trust`,
    recipients: ["all"],
  });
}

export function notifyAttendance(eventName, markedBy) {
  return createNotification({
    type: "attendance",
    title: `Attendance marked`,
    message: `Attendance for "${eventName}" has been recorded by ${markedBy}`,
    recipients: ["all"],
  });
}

export function notifyNewPoster(title) {
  return createNotification({
    type: "poster",
    title: `New announcement: ${title}`,
    message: `A new event poster has been published on the home page`,
    recipients: ["all"],
  });
}

export function notifyProfileUpdate(userId, name) {
  return createNotification({
    type: "profile",
    title: `Profile updated`,
    message: `Your profile information has been updated`,
    recipients: [userId],
  });
}
